
import React from 'react';
import { cn } from "@/lib/utils";

interface CalculatorIconProps {
  size?: number;
  className?: string;
  isActive?: boolean;
}

const CalculatorIcon: React.FC<CalculatorIconProps> = ({ 
  size = 20, 
  className,
  isActive = false
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn(
        "transition-colors duration-200",
        isActive ? "text-primary" : "text-muted-foreground",
        className
      )}
    >
      <rect width="16" height="20" x="4" y="2" rx="2"/>
      <line x1="8" x2="16" y1="6" y2="6"/>
      <line x1="16" x2="16" y1="14" y2="18"/>
      <path d="m9 10 2 2 4-4"/>
      <circle cx="12" cy="16" r="1"/>
    </svg>
  );
};

export default CalculatorIcon;
